import axios from 'axios';

import teamInterceptor from './team.interceptor';
import { getTeamIdFromUrl } from './teamSwitcherHelper';

const teamInterceptorInstance = new teamInterceptor(axios, getTeamIdFromUrl);

teamInterceptorInstance.startIntercepting();

export default teamInterceptorInstance;
